import Carousel from "react-elastic-carousel";
import { useEffect, useRef, useState } from "react";
import partnersLogo from "./partnersLogo";
import "./OurPartners.scss";

const OurPartners = () => {
  const carouselRef = useRef(null);
  let resetTimeout;
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 1 },
    { width: 768, itemsToShow: 3, itemsToScroll: 1 },
    { width: 1200, itemsToShow: 4, itemsToScroll: 1 },
  ];

  const [partnersIcons, setPartnersIcons] = useState(partnersLogo);

  const changeIcon = () => {
    const length = partnersIcons.length;
    if (partnersLogo[0] === partnersIcons[length - 1]) return partnersLogo[1];
    if (partnersLogo[1] === partnersIcons[length - 1]) return partnersLogo[2];
    if (partnersLogo[2] === partnersIcons[length - 1]) return partnersLogo[3];
    if (partnersLogo[3] === partnersIcons[length - 1]) return partnersLogo[0];
  };
  useEffect(() => {
    const clearPartners = setTimeout(() => {
      setPartnersIcons((prevPartners) => prevPartners.concat(changeIcon()));
    }, 3000);
    return () => clearTimeout(clearPartners);
  }, [partnersIcons]);

  return (
    <div className="mb-5 container">
      <Carousel
        ref={carouselRef}
        breakPoints={breakPoints}
        showArrows={false}
        pagination={false}
        enableAutoPlay={true}
        enableMouseSwipe={false}
        autoPlaySpeed={3000}
        onNextEnd={({ index }) => {
          clearTimeout(resetTimeout);

          resetTimeout = setTimeout(() => {
            carouselRef?.current?.goTo(index + 1);
          }, 3000); // same time
        }}
      >
        {partnersIcons.map((logo, index) => (
          <img
            key={index}
            src={logo}
            alt="logos"
            className="Partners_Logo_Img"
          />
        ))}
      </Carousel>
    </div>
  );
};
export default OurPartners;
